import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import {
  InstitutionListQueryParams,
  InstitutionListResponseData,
} from "../../types/institution";
import { toQueryString } from "../../../common/utils";

export const getData = async (params: InstitutionListQueryParams) => {
  const { data } = await api.get<InstitutionListResponseData>(
    `/institutions${toQueryString(params)}`,
  );

  return data;
};

export const useInstitutionsSearch = (
  params: InstitutionListQueryParams,
): QueryObserverBaseResult<InstitutionListResponseData> => {
  const { data, ...props } = useQuery(
    queryKeys.institutionListSearch(params),
    () => getData(params),
    {
      enabled:
        Boolean(params.search) && Boolean(typeof params.search === "string"),
    },
  );
  return { data, ...props };
};
